import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Workflow Mapping", desc: "We model your operations first, then engineer software around real constraints." },
  { title: "Domain-Driven Design", desc: "Architecture aligned to business capabilities for long-term product clarity." },
  { title: "Security by Default", desc: "Access controls, auditability, and compliance-ready foundations from day one." },
  { title: "Integration Layer", desc: "Connect billing, ERP, CRM, communication, and analytics into a single system." },
  { title: "Admin & Reporting", desc: "Decision-ready dashboards with role-specific visibility and operational metrics." },
  { title: "Continuous Delivery", desc: "Incremental releases, clear roadmaps, and stable velocity post-launch." },
];

const CustomSoftware = () => (
  <StitchFeaturePage
    label="SOFTWARE & ENTERPRISE"
    title="Software tailored to"
    titleAccent="your operation."
    subtitle="No template lock-in. We build robust internal and customer-facing platforms for your exact business model."
    features={features}
    ctaLabel="BUILD CUSTOM SOFTWARE"
  />
);

export default CustomSoftware;